export default __webpack_public_path__ + "static/media/icon-normal.a0a4e26f.svg";